<script setup lang="ts"></script>

<template>
  <div class="tile">
    <slot />
  </div>
</template>

<style scoped>
  .tile {
    border-radius: 16px;
    background-color: var(--sf-base-background-white);
    padding: 16px;
  }
</style>
